import { NavLink } from 'react-router-dom'

import { t } from 'lib/i18n'

const TABS = [
  { ar: 'المستخدمون', en: 'Users', to: '/admin/users' },
  { ar: 'الأدوار والصلاحيات', en: 'Roles and permissions', to: '/admin/roles' },
  { ar: 'الدعوات', en: 'Invitations', to: '/admin/invitations' },
]

/** Shared sub-nav across the three Users & roles admin pages (Figma: Admin / 20 · Users — the Users/Roles &
 *  permissions/Invitations tab strip at the top of that frame). */
export const AdminTabs = ({ pendingInvitations }: { pendingInvitations?: number }) => (
  <nav className="tabs" aria-label={t('إدارة المستخدمين', 'Users and roles')}>
    {TABS.map((tab) => (
      <NavLink key={tab.to} to={tab.to} className={({ isActive }) => (isActive ? 'tab is-active' : 'tab')}>
        {t(tab.ar, tab.en)}
        {tab.to === '/admin/invitations' && pendingInvitations ? ` (${pendingInvitations})` : ''}
      </NavLink>
    ))}
  </nav>
)
